// ----------------------------------------------------------------------

export default function Typography(theme) {
  return {
    MuiTypography: {
      defaultProps: {
        // MUI's defaults plus the public-site role variants from theme/typography.js.
        // (Supplying variantMapping replaces MUI's map, so the defaults are restated.)
        variantMapping: {
          h1: 'h1',
          h2: 'h2',
          h3: 'h3',
          h4: 'h4',
          h5: 'h5',
          h6: 'h6',
          subtitle1: 'h6',
          subtitle2: 'h6',
          body1: 'p',
          body2: 'p',
          inherit: 'p',
          heroHeadline: 'h1',
          heroSubheadline: 'p',
          footerHeading: 'h2',
          footerText: 'p',
          footerLegal: 'p',
        },
      },
      styleOverrides: {
        paragraph: {
          marginBottom: theme.spacing(2),
        },
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}
